import React from 'react';
import { Link } from 'react-router-dom';

//	L O C A L I Z A T I O N

import { locale___SbEventViewComponent } from './md-events-view.locale';

//	S T Y L E

import './md-events-view.scss';

//	F U N C S

import { funcs_numbers } from '../../funcs/funcs.numbers';

//	S T A T E   -   P R O P S

import { props___MdEventsViewModal, state___MdEventsViewModal, state___MdEventsViewModal___default } from './md-events-view.state';

//	T Y P E S

import { type___api___response } from '../../types/types.api-response';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';
import { service_RestApiService } from '../../services/service-api';

//	C O M P O N E N T S

import Com404Component from '../../components/com-404/com-404';
import ComButtonShareComponent from '../../components/com-buttons/com-button-share/com-button-share';
import ComEventDisclaimerViewComponent from '../../components/com-events/com-event-disclaimer-view/com-event-disclaimer-view';
import ComEventTimeScheduleComponent from '../../components/com-events/com-event-timeschedule/com-event-timeschedule';
import ComGalleryPlaceholderComponent from '../../components/com-gallery/com-gallery-placeholder/com-gallery-placeholder';
import ComPoiComponent from '../../components/com-poi/com-poi/com-poi';
import ComSpinnerComponent from '../../components/com-spinners/com-spinner/com-spinner';
import ComTextComponent from '../../components/com-texts/com-text/com-text';
import ComUserComponent from '../../components/com-user/com-user/com-user';

//	C L A S S

export default class MdEventsViewModal extends React.Component<props___MdEventsViewModal, state___MdEventsViewModal> {

//#region 																							D E C L A R A T I O N S

	private readonly _API: service_RestApiService = new service_RestApiService();
	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

	private readonly funcs___numbers: funcs_numbers = new funcs_numbers();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___MdEventsViewModal,
	) {
		super(props);
		this.state = state___MdEventsViewModal___default;
	}

//#endregion

//#region 																							R E A D   P R O P S

	private read_props___event = async () => {
		const ___temp___event___props: type___api___response = await this._API.events___read___single(this.state.event___id);
		this.setState({
			event___props: ___temp___event___props.data,
			event___props___isLoading: false,
		}, () => {
			this.setState({
				event___user___props: this.state.event___props['event_user'],
			}, async () => {
				await Promise.all([
					await this.read_props___event___poi(),
					await this.read_props___event___user(),
				]);
			});
		});
	}

	private read_props___event___poi = async () => {
		if (this.state.event___props['event_poi']) {
			const ___temp___event_poi___props: type___api___response = await this._API.poi___read___single(this.state.event___props['event_poi']);
			this.setState({
				event___poi___props: ___temp___event_poi___props.data,
			});
		}
	}

	private read_props___event___user = async () => {
		if (this.state.event___props['event_user_public'] && this.state.event___props['event_user_public'] === true) {
			const ___temp___event_poi___props: type___api___response = await this._API.users___read___single('id', this.state.event___props['event_user']['user_id']);
			this.setState({
				event___user___props: ___temp___event_poi___props.data,
			});
		}
	}

//#endregion

//#region 																							L I F E C Y C L E

	componentDidMount() : void {
		const ___event_id: string | null = this.props.event_id;
		if (___event_id) {
			this.setState({
				event___id: ___event_id,
			}, async () => {
				await this.read_props___event();
			});
		}
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			{(this.state.event___props___isLoading === true) ? <>
				<div className="md-modal---discover-modal-container md-event-view---container">
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />
					<ComSpinnerComponent size="small"/>
				</div>
			</> : <>
				{(this.state.event___props !== null) ? <>
					<div className="md-modal---discover-modal-container md-event-view---container">

						<ComEventTimeScheduleComponent event_props={ this.state.event___props } />
				
						<div className="sb-event-view---poster">
							{(this.state.event___props['event_poster'] && this.state.event___props['event_poster'].length > 0) ? <>
								<img src={ this.state.event___props['event_poster'] } />
							</> : <>
								<ComGalleryPlaceholderComponent placeholder_path={ '/assets/markers/events/' + this.state.event___props['event_category']['event_category_icon'] + '.png' } />
							</>}
						</div>

						<h6>
							<span>{ this.state.event___props['event_category']['event_category_name'] }</span>
							{(this.state.event___props['event_coords_distance'] > -1) ? <>
								<span>{ this._LOCALE.translate(locale___SbEventViewComponent.distance_from_you, [this.funcs___numbers.number___format_as_string___distance(this.state.event___props['event_coords_distance'])]) }</span>
							</> : <></>}
						</h6>

						<h3>{ this.state.event___props['event_name'] }</h3>

						{(this.state.event___props['event_description'] && this.state.event___props['event_description'].length > 0) ? <>
							<ComTextComponent text={ this.state.event___props['event_description'] }/>
							<br />
						</> : <></>}

						<ComButtonShareComponent element_type="event" element={ this.state.event___props } />

						{(this.state.event___poi___props !== null) ? <>
							<section style={{marginBottom:'10pt'}}>
								<Link to={ '/view/poi/' + this.state.event___poi___props['poi_id'] }>
									<ComPoiComponent poi_props={ this.state.event___poi___props } />
								</Link>
							</section>
						</> : <></>}

						{(this.state.event___props['event_user_public'] && this.state.event___props['event_user_public'] === true && this.state.event___props['event_user'] !== null) ? <>
							<br />
							<br />
							<br />
							<p className="input---nb-label" style={{textAlign:'center'}}>{ this._LOCALE.translate(locale___SbEventViewComponent.event_user_label)}</p>
							{(this.state.event___user___props !== null) ? <>
								<ComUserComponent user___props={ this.state.event___user___props } />
							</> : <></>}
						</> : <></>}

						<br />
						<br />
						<br />

						<ComEventDisclaimerViewComponent/>

					</div>
				</> : <>
					<Com404Component/>
				</>}
			</>}
		</>;
	}

//#endregion

}